import React from 'react';
import { Link } from 'react-router-dom';

const FeatureProjects = () => {
  return (
    <div>
          {/* Projects Preview Section */}
      <section className="px-20 py-20">
        <h2 className="text-4xl font-bold text-center mb-10 text-white">
          Featured Projects
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            { id: 1, title: "Web Development Project", desc: "A modern, responsive website built with React.", img: "https://miro.medium.com/1%2AV-Jp13LvtVc2IiY2fp4qYw.jpeg" },
            { id: 2, title: "UI/UX Design Project", desc: "User-centered design for a mobile app.", img: "https://www.mindinventory.com/blog/wp-content/uploads/2023/11/difference-between-ui-ux.webp" },
            { id: 3, title: "App Development Project", desc: "A modern App built in Flutter.", img: "https://www.datocms-assets.com/22695/1751319499-1741706148-key-elements-of-a-branding.webp" },
          ].map((project) => (
            <div
              key={project.id}
              className="bg-white shadow rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:shadow-blue-600"
            >
              <img
                src={project.img}
                alt={`Project ${project.id}`}
                className="w-full h-40 object-cover"
              />
              <div className="p-5">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {project.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {project.desc}
                </p>
                <Link
                  to="/projects"
                  className="text-blue-600 font-medium hover:underline"
                >
                  Learn More →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}
export default FeatureProjects
